import React from "react"
import dayjs from "dayjs"
import { Box, TableHead, TableBody, TableRow } from "@mui/material"
import { COLORS } from "../../../utils"
import { StyledTable, StyledHeaderCell, StyledBodyCell } from "../../../components/styled/StyledTableComponents"

const useStyles = {
  shortage: { color: COLORS.RED_ERROR },
  qtyUnit: { color: COLORS.BLACK_500 },
}

const IngredientsTable = ({ ingredients = [{ name: "Aucun ingrédient renseigné" }] }) => {
  return (
    <Box>
      <StyledTable>
        <TableHead>
          <TableRow sx={{ py: 2}}>
            {["Ingrédients", "Quantité disponible/nécessaire", "Prochaine livraison"].map((label, i) => (
              <StyledHeaderCell key={i}>{label}</StyledHeaderCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {ingredients.map((ingredient, index) => (
            <TableRow key={index}>
              <StyledBodyCell leftEdge={true} lastTableRow={index === ingredients.length - 1}>{ingredient.name}</StyledBodyCell>

              <StyledBodyCell lastTableRow={index === ingredients.length - 1}>
                  <span style={ingredient.isShort ? useStyles.shortage : {}}>
                    {ingredient.available != null ? Math.round(ingredient.available * 100) / 100 : "-"}
                  </span>
                  /{ingredient.needed != null ? Math.round(ingredient.needed * 100) / 100 : "-"} <span style={useStyles.qtyUnit}>kg</span>
              </StyledBodyCell>

              <StyledBodyCell rightEdge={true} lastTableRow={index === ingredients.length - 1}>
                {ingredient.isShort && ingredient.nextDelivery ? (
                  <>
                    {dayjs(ingredient.nextDelivery.date).format("DD/MM/YY")}{" "}
                    <span style={useStyles.qtyUnit}>({ingredient.nextDelivery.qty} kg)</span>
                  </>
                ) : ( "-" )}
              </StyledBodyCell>
            </TableRow>
          ))}
        </TableBody>
      </StyledTable>
    </Box>
  )
}

export default IngredientsTable